
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/b1b2f0b21fd94ab4a00dfc9a5951f0a8/05ef9632faa424de10622c99cf932b61.jpeg"
              alt="Rastrek Logo"
              className="h-12 w-auto object-contain mb-6"
            />
            <p className="text-gray-400 mb-6 text-sm leading-relaxed">
              A Rastrek oferece o melhor sistema de rastreamento veicular do mercado, com tecnologia de ponta, monitoramento 24h e o melhor custo-benefício para proteger seu patrimônio.
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-yellow-500 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-yellow-500 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://wa.me/5511954662476"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-yellow-500 transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-yellow-500">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <a href="#beneficios" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  Benefícios
                </a>
              </li>
              <li>
                <a href="#provas-sociais" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  Depoimentos
                </a>
              </li>
              <li>
                <a href="#qualidades" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  Qualidades
                </a>
              </li>
              <li>
                <a href="#instalacao" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  Instalação
                </a>
              </li>
              <li>
                <a href="#contato" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-yellow-500">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-yellow-500 mt-1"></i>
                <a href="tel:+5511954662476" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  (11) 95466-2476
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-whatsapp-line text-yellow-500 mt-1"></i>
                <a href="https://wa.me/5511954662476" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-yellow-500 mt-1"></i>
                <a href="mailto:rastrekgroupsp@gmail.com" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  rastrekgroupsp@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-yellow-500 mt-1"></i>
                <span className="text-gray-400 text-sm">
                  Seg - Sex: 8h às 18h<br />Sáb: 8h às 12h
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Rastrek. Todos os direitos reservados.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
